export default {
  loading: "Loading...",
  open: "Open",
  close: "Close",
  stake: "Stake",
  crdr: "W/L",
  item: "Item",
  valid: "Valid",
  home_preferences: "Home Preferences",
  quick_links: "Quick Links",
  language: "Language",
  home_page: "Home",
  favorites: "Favourites",
  note: "Note",
  my_bets: "My Bets",
  my_account: "My Account",
  contact_us: "Contact Us",
  report: "Report",
  help_support: "Help & Support",
  currency: "Currency",
  others: "Others",
  welcome: "Welcome",
  account_id: "Account ID",
  password: "Password",
  account: "Account",
  all_sports: "All Sports",
  my_sports: "Sports",
  action: "Action",
  accept_better_odds: "Accept Better Odds",
  accept_any_odds: "Accept Any Odds",
  auto_refresh_odds: "Auto Refresh Odds",
  auto_refresh: "Auto Refresh",
  auto_refreshing: "Auto Refreshing...",
  all_markets: "All Markets",
  available_balance: "Available Balance",
  athletics: "Athletics",
  american_football: "American Football",
  aussie_rules_football: "Aussie Rules Football",
  gmail: "Gmail",
  contact_number: "Contact Number",

  away: "Away",

  all: "All",
  accepted: "Accepted",
  add: "Add",
  add_homescreen: "Add to Home screen",
  abandoned: "Abandoned",

  bet_slip: "Bet Slip",
  bet_credit: "Bet Credit",
  bet_list: "Bet List",
  betting: "Betting",
  balance: "Balance",

  betting_statement: "Betting Statement",
  betting_rules: "Betting Rules",
  bet_types: "Bet Types",
  bs: "B/S",
  bet_summary: "Bet Summary",
  bets: "Bets",
  basketball: "Basketball",
  baseball: "Baseball",
  badminton: "Badminton",
  bandy: "Bandy",
  boxing: "Boxing",
  beach_soccer: "Beach Soccer",
  back: "Back",

  casino: "Casino",
  cash_balance: "Cash Balance",
  change_account_password: "Change Account Password",
  current_password: "Current Password",
  confirm_new_password: "Confirm New Password",
  customize_sports_order: "Customize Sports Order",
  choice: "Choice",
  credit: "Credit",
  commission: "Commission",
  customize: "Customize",
  cancel: "Cancel",
  confirmation: "Confirmation",
  continue_bet: "Continue Bet",
  customer_service: "Customer Service Hotline",
  cricket: "Cricket",
  cycling: "Cycling",
  copa_america: "Copa America",
  combinations: "Combinations",
  create_room: "Create Private Room",

  darts: "Darts",
  debit: "Debit",
  display_language: "Display Language",
  default_event_sorting: "Default Event Sorting",
  default_stake: "Default Stake",
  date: "Date",
  draw: "Draw",
  draw_cancel: "Draw",
  dec: "DEC",
  double_line: "Double Line",
  disable: "Disable",
  dec_odds: "DEC | Decimal Odds",
  id_odds: "IND | Indo Odds",
  double_chance: "Double Chance",
  details: "Details",

  enable: "Enable",
  event_sorting: "Event Sorting",
  e_sports: "E-Sports",
  esports2: "E-Sports 2",
  edit: "Edit",
  early: "Early",
  event: "Event",
  even: "Even",
  email: "Email",
  esports: "E-Sports",
  entry_fee: "Entry Fee",
  exclusive: "Exclusive",
  event_worldcup: "Worldcup 2026",
  event_euro: "EURO 2024",
  event_copa: "COPA 2024",
  event_olympic: "Olympic 2024",
  event_club_worldcup: "CLUB WORLD CUP",
  event_women_euro: "WOMEN's EURO",
  event_nation_league: "NATION LEAGUE",
  event_fifa_club: "FIFA CLUB",

  es_101: "Map 1",
  es_102: "Map 2",
  es_103: "Map 3",
  es_104: "Map 4",
  es_105: "Map 5",
  es_106: "Map 6",
  es_107: "Map 7",
  es_108: "Map 8",
  es_109: "Map 9",
  es_110: "Map 10",

  fd_101: "1ST Prize",
  fd_102: "2ND Prize",
  fd_103: "3RD Prize",

  first_goal: "First Goal",
  first_half: "First Half",
  final: "Final",
  full_time: "Full Time",
  from: "From",
  field_hockey: "Field Hockey",
  futsal: "Futsal",
  fd: "4D Special",
  fishing: "Fishing",
  fold: "Folds",

  gaelic_football: "Gaelic Football",
  golf: "Golf",
  games: "Games",
  given_credit: "Given Credit",
  group: "Group",
  goal: "Goal",
  general: "General",
  general_betting_rules: "General Betting Rules",
  general_rules_market: "General Rules: Market (Bet Type)",

  half_time: "Half Time",
  hide_header: "Hide Header",
  hk: "HK",
  hk_odds: "HK | Hong Kong Odds",
  hdp: "HDP",
  home: "Home",
  hotline: "Hotline",
  handball: "Handball",
  hurling: "Hurling",
  hour: "Hour",
  highlight: "Highlights",

  id: "ID",
  ice_hockey: "Ice Hockey",

  joined: "Joined Only",
  join_now: "Join Now",
  jackpot: "Jackpot",

  keno: "Keno",
  kickoff: "Kickoff",
  kabbadi: "Kabbadi",
  kof: "King of Figthers",
  ko: "K.O By",

  lose: "Lose",
  lose_half: "Lose Half",
  lottery: "Lottery",
  login: "Login",
  logout: "Logout",
  last_login: "Last Login",
  last_transaction: "Last Transaction",
  live_streaming: "Live Streaming",
  live_match: "Live Match",
  live_chat: "Live Chat",
  live: "Live",
  virtual: "Virtual",
  live_tv: "Live TV",
  livecasino: "Live Casino",
  loss: "Loss",
  lost: "Lost",
  last_bet: "Last Bet",
  last_goal: "Last Goal",
  leave_room: "Leave Room",
  last_betting_time: "Last Betting Time",
  lose_all: "Lose All",

  mobile: "Mobile",
  message: "Message",
  my_bet: "My Bet",
  my_favorites: "My Favourites",
  market_type: "Market Type",
  match: "Match",
  message_history: "Message History",
  my: "MY",
  market: "Market",
  main_markets: "Main Markets",
  my_odds: "MY | Malay Odds",
  mmo_parlay: "Myanmar Parlay",
  mmo_odds: "Myanmar Odds",
  min: "Min",
  max: "Max",
  max_payout: "Max payout",
  main: "Main",
  corners: "Corners/Booking",
  specials: "Specials",
  mix_parlay: "Mix Parlay",
  mma: "Mixed Martial Arts (MMA)",
  motorsports: "Motorsports",
  muay_thai: "Muay Thai",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  matches: "Matches",
  mini_arcade: "Mini Arcade",
  match_started: "-",

  no_goal: "No Goal",
  normal_announcements: "Normal Announcements",
  nickname: "Nickname",
  new_password: "New Password",
  new: "New",
  "no/": "No.",
  normal_sorting: "Normal Sorting",
  netball: "Netball",
  newsinfo: "News & Info",
  next: "Next",

  olympic: "Olympic",
  other_markets: "Other Markets",
  outstanding: "Outstanding",
  odds_type: "Odds Type",
  odds: "Odds",
  opening_balance: "Opening Balance",
  outright: "Outright",
  oe: "O/E",
  on: "ON",
  off: "OFF",
  outstanding_bet: "Outstanding Bet",
  over: "Over",
  odd: "Odd",
  official_link: "Official Link",
  owner: "Owner",
  ou: "O/U",

  password_expiry: "Password Expiry",
  parlay: "Parlay",
  parlay_early: "Parlay Early",
  page_display: "Page Display",
  page_type: "Page Type",
  page_size: "Page Size",
  personal_message: "Personal Message",
  process_bet: "Place Bet",
  payout: "Payout",
  pending: "Pending",
  personal: "Personal",
  play_now: "Play Now",
  parlay_generator: "Parlay Generator",
  private: "Private",
  pool: "Payout $",
  players: "Player",
  points: "Points",
  prize: "Prize",
  play_to_earn: "Play to Earn",

  quick_bet: "Quick Bet",
  qq: "QQ",

  room: "Room",
  result: "Result",
  restore: "Restore",
  remark: "Remark",
  ref_no: "Ref No.",
  remove_from_parlay: "Remove From Parlay",
  running: "Running",
  reject: "Rejected",
  rejected: "Rejected",
  rugby: "Rugby",
  roundof16: "Rounds of 16",
  quater_finals: "Quater Finals",
  semi_finals: "Semi Finals",
  room_id: "Room ID",
  refund: "Refund",

  skype: "Skype",
  sports: "Sports",
  show_balance: "Show Balance",
  statement: "Statement",
  settings: "Settings",
  search_team: "Search Team",
  show_header: "Show Header",
  submit: "Submit",
  set_nickname: "Set Nickname",
  single: "Single",
  save: "Save",
  show_score_map: "Show Score Map",
  status: "Status",
  sort: "Sort",
  sportsbook: "Sportsbook",
  sum: "SUM",
  special_announcements: "Sepcial Announcements",
  subtotal: "Subtotal",
  single_line: "Single Line",
  sort_by_time: "Sort by Time",
  slots: "Slots",
  select_leagues: "Select Leagues",
  special: "Special",
  scroll_bottom: "Tap to scroll to betting area",
  swipe_to_search: "Swipe To Search",
  soccer: "Soccer",
  squash: "Squash",
  sepak_takraw: "Sepak Takraw",
  snooker: "Snooker/Pool",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  suite_sexy: "Sexy Casino",
  suite_onlive: "Onlive Casino",
  suite_mt: "MT Casino",
  suite_foxy: "Foxy Casino",
  sfv_101: "Round 1",
  sfv_102: "Round 2",
  sfv_103: "Round 3",
  sfv_104: "Round 4",
  sfv_105: "Round 5",
  settlement: "Settlement",
  settled_amount: "Settlement Amount",
  sfv: "Street Figther V",
  search: "Search",
  sysparlay: "System Parlay",
  stake_per_bet: "Stake Per Bet",
  score: "Score",
  winner: "Winner",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  slot_epwmg: "Epicwin Mini",
  selected: "Selected",
  select_matches: "Select Matches",
  slots_rules: "Slot Games Rules",

  turnover: "Turnover",
  today: "Today",
  time: "Time",
  team: "Team",
  to: "To",
  trans_time: "Trans.Time",
  total: "Total",
  total_goal: "Total Goal",
  treble: "Treble",
  total_bets: "Total Bets",
  tnc: "General Terms & Conditions",
  tennis: "Tennis",
  table_tennis: "Table Tennis",
  telegram: "Telegram",
  tournament: "Tournament",
  total_points: "Total Points",
  tournament_refund: "Tournament Refund",

  under: "Under",
  void: "Void",
  volleyball: "Volleyball",
  void_list: "Void List",
  view_odds: "View Odds",
  video: "Video",

  won_all: "Won All",
  won_half: "Won Half",
  win_half: "Won Half",
  win: "Win",
  won: "Won",
  waiting: "Waiting",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "Winter Sports",
  water_polo: "Water Polo",
  winner_rank: "Winner Rank",

  yes: "Yes",
  no: "No",

  yesterday: "Yesterday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",

  all_league: "All",
  match_completed: "Completed",
  match_pending: "Result Pending",
  match_cancelled: "Refund",
  match_cancelled_1h: "Refund 1H",
  match_cancelled_2h: "Refund 2H",
  match_suspended: "Abandoned",
  match_suspended_1h: "Abandoned 1H",
  match_suspended_2h: "Abandoned 2H",

  check_all: "Check All",
  selected_only: "Selected Only",
  filtered: "Filtered",
  turn_on: "ON",
  turn_off: "OFF",

  more_bet_types: "More Bet Types",
  switch_to_desktop: "Switch to Desktop",
  logo: "Logo",
  worldcup_timer: "World Cup countdown",

  events: "Events",
  brackets: "Brackets",
  standing: "Standing",

  big_small: "Big/Small",
  odd_even: "Odd/Even",

  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total of Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  total_winlose: "Total Win/Lose",
  tomorrow: "Tomorrow",

  news: "News",
  more: "More",
  current_live: "Current Live",
  upcoming: "Upcoming",
  prematch: "Prematch",
  desktop_view: "Desktop View",
  back_to_lobby: "Back to Lobby",
  coming_soon: "Coming Soon",
  no_record: "No record found",
  bet_time: "Bet Time",
  seven_days: "Last 7 Days",
  fourteen_days: "Last 14 Days",
  winlose: "Win/Lose",
  all_transaction: "All Transaction",
  transfer: "Transfer",
  hide: "Hide",
  more_details: "More details",
  bet: "Bet",
  comm: "Comm",
  settled: "Settled",
  total_stake: "Total Stake",
  deselect_all: "Deselect All",
  select_all: "Select All",
  done: "Done",
  early_all: "Early (All)",
  more_markets: "More Markets",
  folds_2: "2 Folds",
  folds_3: "3 Folds",
  folds_4: "4 Folds",
  folds_5: "5 Folds",
  folds_6: "6 Folds",
  folds_7: "7 Folds",
  folds_8: "8 Folds",
  folds_9: "9 Folds",
  folds_10: "10 Folds",
  folds_11: "11 Folds",
  folds_12: "12 Folds",
  go_today_matches: "Go Today Matches",
  go_live_matches: "Go Live Matches",
  remember_stake: "Remember Stake",
  confirm: "Confirm",
  parlay_slip: "Parlay Slip",
  parlay_slip_selection: "Parlay Slip - Selection",
  remove_all: "Remove All",
  add_more_selection: "Add More Selection",
  retain_selections: "Retain Selections",
  settled_remark: "Note: Bets from today market are displayed, settled match's tickets will be moved to statement.",
  w4d: "4D",
  tutorial_tooltips: "How to install this app on home screen",
  tutorial: "Tutorial",
  dismiss: "Dismiss",
  euroDate: "12 JUNE - 12 JULY",
  goto_statement: "Go to Statement",
  no_bet: "No Bet",

  random_pick: "Generate",
  add_pick: "Add To Bet Slip",

  worldcup: "WORLD CUP 2022",
  time_remaining: "Time Remaining",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "V-Games",
  feedback: "User Experience Feedback",
  ranking: "Ranking",
  total_winning: "Total Winning",
  first_prize: "1st Prize",
  second_prize: "2nd Prize",
  third_prize: "3rd Prize",
  place: "Place",
  current_point: "Current Point",
  free_room: "Free Room",
  last_join_time: "Last Join Time",
  archery: "Archery",
  ufc: "UFC",
  winter_olympic: "Winter Olympic",
  no1: "1st Place Winner",
  adjustment: "Adjustment",
  poker: "Poker",
  poker_db: "DB Poker",
  yellow: "Yellow",
  blue: "Blue",
  first_ball: "1st Ball",
  best_5_balls: "Best 5 Balls",
  binary_allin: "Binary",
  best_3_balls: "Best 3 Balls",
  red: "Red",
  green: "Green",
  ball_1: "Ball #1",
  ball_2: "Ball #2",
  ball_3: "Ball #3",

  cashout: "Cash Out",
  cashout_amount: "Cash Out Amount",
  round1: "Round 1",
  round2: "Round 2",
  round3: "Round 3",

  round1_1stBoom: "R1 1st BOOM",
  round2_1stBoom: "R2 1st BOOM",
  round3_1stBoom: "R3 1st BOOM",

  modern_view: "Modern View",
  switching_to_modern_view: "Switching to modern view...",
  cashout: "Cash Out",
  available: "Available",

  time_machine_tm: " (T.Machine)",
  beta_tag: "Beta"
};
